import { Box, Col } from '@opendoor/atoms/box';

import styles from './SpinningGradient.module.css';

interface SpinningGradientProps {
  children: React.ReactNode;
}

const SpinningGradient: React.FC<SpinningGradientProps> = ({ children }) => {
  return (
    <Col className="relative mt-[200px] bg-od-bg-inverse-primary max-md:mt-[100px]">
      <Col className="relative z-[2]">{children}</Col>
      <Box className="pointer-events-none absolute inset-0 overflow-visible">
        <Box className={styles.blur}>
          <Box className={styles.gradientMask}>
            <Box className={styles.spinningGradient} />
          </Box>
        </Box>
      </Box>
    </Col>
  );
};

export default SpinningGradient;
